export default "__VITE_ASSET__Desh85zY__"